import { HAMBURGER_NAVIGATION_RECEIVE } from '../constants';

export const hamburgerNavigation = (state = { menu: [] }, action) => {
    switch (action.type) {
        case HAMBURGER_NAVIGATION_RECEIVE:
        return {
            ...state,
            ...action.payload,
        };
    default:
        return state;
    }
};